import { useForm } from 'react-hook-form'
import { useEffect, useState } from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { useDispatch, useSelector } from 'react-redux'
import { InterStateActions } from '../../../store/InterState_Slice'

const SenderForm = ({ set }) => {
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm()
  const [isClear, setIsClear] = useState(false)

  const dispatch = useDispatch()
  const SenderDetails = useSelector((state) => state.Interstate.Sender)

  const { PriceDetails} = useSelector(
    (state) => state.Interstate,
  )

  useEffect(() => {
    AOS.init({
      duration: 2000,
    })
  }, [])

  useEffect(() => {
    if (!isClear) {
      return
    } else {
      reset()
    }
  }, [isClear, reset])

  useEffect(() => {
    if (SenderDetails !== '') {
      reset(SenderDetails)
    }
  }, [SenderDetails, reset])

  const onSubmit = (data) => {
    if (data) {
      dispatch(InterStateActions.GetSender(data))
      set(1)
      setIsClear(true)
    } else setIsClear(false)
  }

  return (
    <form data-aos="fade-zoom-in" onSubmit={handleSubmit(onSubmit)}>
      <div className="Top">
        <div className="Box">
          <label htmlFor="first">FIRST NAME</label>
          <input
            id="first"
            placeholder="First name"
            className={`${errors.first_name ? 'error' : 'noError'}`}
            {...register('first_name', { required: true, onChange:()=>dispatch(InterStateActions.GetPriceDetails('')) })}
          />
          {errors.first_name && (
            <span className={`${errors.first_name ? 'errorText' : ''}`}>
              first name field is required
            </span>
          )}
        </div>
        <div className="Box">
          <label htmlFor="last">LAST NAME</label>
          <input
            id="last"
            placeholder="last name"
            className={`${errors.last_name ? 'error' : 'noError'}`}
            {...register('last_name', { required: true })}
          />
          {errors.last_name && (
            <span className={`${errors.last_name ? 'errorText' : ''}`}>
              last name field is required
            </span>
          )}
        </div>
      </div>
      <div className="Box">
        <label htmlFor="PHONE NUMBER">EMAIL</label>
        <input
          id="phone-number"
          type="email"
          placeholder="Email"
          className={`${errors.sender_email ? 'error' : 'noError'}`}
          {...register('sender_email', { required: true })}
        />
        {errors.sender_email && (
          <span className={`${errors.sender_email ? 'errorText' : ''}`}>
            Email field is required
          </span>
        )}
      </div>
      <div className="Box">
        <label htmlFor="PHONE NUMBER">PHONE NUMBER</label>
        <input
          id="phone-number"
          type="tel"
          placeholder="Phone Number"
          className={`${errors.mobile ? 'error' : 'noError'}`}
          {...register('mobile', { required: true })}
        />
        {errors.mobile && (
          <span className={`${errors.mobile ? 'errorText' : ''}`}>
            Phone number field is required
          </span>
        )}
      </div>
      <div className="Box">
        <label htmlFor="weight">Weight</label>
        <input
          id="weight"
          type="tel"
          placeholder="Weight"
          className={`${errors.weight ? 'error' : 'noError'}`}
          {...register('weight', { required: true })}
        />
        {errors.weight && (
          <span className={`${errors.weight ? 'errorText' : ''}`}>
            weight field is required
          </span>
        )}
      </div>
      <div className="Box">
        <label htmlFor="street">ADDRESS 1</label>
        <input
          id="street"
          placeholder="Address"
          className={`${errors.address_one ? 'error' : 'noError'}`}
          {...register('address_one', { required: true })}
        />
        {errors.address_one && (
          <span className={`${errors.address_one ? 'errorText' : ''}`}>
            Address field is required
          </span>
        )}
      </div>
      <div className="Box">
        <label htmlFor="house">ADDRESS 2 (Optional)</label>
        <input
          id="house"
          placeholder="Address 2 (Optional)"
          {...register('address_two')}
        />
      </div>
      <div className="Top">
        <div className="Box">
          <label htmlFor="CITY">STATE</label>
          <input
            id="STATE"
            type="text"
            placeholder="State"
            className={`${errors.state ? 'error' : 'noError'}`}
            {...register('state', { required: true })}
          />
          {errors.state && (
            <span className={`${errors.state ? 'errorText' : ''}`}>
              State field is required
            </span>
          )}
        </div>
        <div className="Box">
          <label htmlFor="CITY">CITY</label>
          <input
            id="CITY"
            type="text"
            placeholder="CITY"
            className={`${errors.city ? 'error' : 'noError'}`}
            {...register('city', { required: true })}
          />
          {errors.city && (
            <span className={`${errors.city ? 'errorText' : ''}`}>
              City field is required
            </span>
          )}
        </div>
      </div>
      <input type="submit" value="CONTINUE" />
    </form>
  )
}

export default SenderForm
